import type { ViewDTO, ViewUpsertDTO } from '@tempo-io/roadmap-dto';
import { tempoApi } from '../tempoApi';

const fetchViews = async (roadmapId: number): Promise<ViewDTO[]> => {
  const response = await tempoApi().get<ViewDTO[]>(`api/v1/roadmap/${roadmapId}/view`);
  return response.json();
};

const fetchView = async (id: number): Promise<ViewDTO> => {
  const response = await tempoApi().get(`api/v1/roadmap/view/${id}`);
  return response.json();
};

const upsertView = async (id: number | undefined, data: ViewUpsertDTO): Promise<ViewDTO> => {
  const url = id ? `api/v1/roadmap/view/${id}` : `api/v1/roadmap/view`;
  return tempoApi()
    .put(url, {
      json: data,
    })
    .json<ViewDTO>();
};

const deleteView = async (id: number): Promise<void> => {
  await tempoApi().delete(`api/v1/roadmap/view/${id}`);
};

export const ViewApi = {
  fetchViews,
  fetchView,
  upsertView,
  deleteView,
} as const;
